import { render, staticRenderFns } from "./gdDryBoard.vue?vue&type=template&id=d361de9a&scoped=true"
import script from "./gdDryBoard.vue?vue&type=script&lang=js"
export * from "./gdDryBoard.vue?vue&type=script&lang=js"
import style0 from "./gdDryBoard.vue?vue&type=style&index=0&id=d361de9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d361de9a",
  null
  
)

export default component.exports